import { Component } from '@angular/core';

import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './report-abuse.component.html',
    standalone: false
})
export class ReportAbuseModalComponent extends BaseModalDirective {}
